import { render, staticRenderFns } from "./HiwBottomSection.vue?vue&type=template&id=8817062a&scoped=true&"
import script from "./HiwBottomSection.vue?vue&type=script&lang=js&"
export * from "./HiwBottomSection.vue?vue&type=script&lang=js&"
import style0 from "./HiwBottomSection.vue?vue&type=style&index=0&id=8817062a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8817062a",
  null
  
)

export default component.exports